module.exports = __webpack_public_path__ + "img/xpu-ha-beach-2.55a469d1.jpg";